import { atom } from '@reatom/framework'
import { match } from 'ts-pattern'

import { ExploreFeedType } from '../../model/explore-feed-type'

import type { PairMetrics } from '@root/entities/pair'
import type { TradeSettingsQuick } from '@root/entities/trade-settings/model'

export type ExploreTableFeedType =
  | typeof ExploreFeedType.Trending
  | typeof ExploreFeedType.New
  | typeof ExploreFeedType.Cooking

/** Five minutes: the window the new-pairs feed is actually read in. */
export const exploreTablePeriodAtom = atom<PairMetrics.MetricsSpan>(
  '5M',
  'exploreTablePeriodAtom',
)

export const mapToQuickBuySection = (
  feedType: ExploreTableFeedType,
): TradeSettingsQuick.QuickSwapSection => {
  return match(feedType)
    .returnType<TradeSettingsQuick.QuickSwapSection>()
    .with(ExploreFeedType.Trending, () => 'trendingTable')
    .with(ExploreFeedType.New, () => 'newPairsTable')
    .with(ExploreFeedType.Cooking, () => 'cookingTable')
    .exhaustive()
}
